import { Logger } from "neo-common";

/**
 * Definitions for payline for all kind of reels.
 * @class PaylinesDefinitions
 */
export class PaylinesDefinitions {
    private static _paylineGroupsDefinitions: Object = {};

    /**
     * Initialize payline definiftion specific for game.
     * @method initializePaylineDefinitions
     * @param paylineGroupId string
     * @return void
     */
    static initializePaylineDefinitions(paylineGroupId: string) {
        var definition: Object = {};

        switch (paylineGroupId) {
            case "5x3_hotAfrica":
                definition[1] = [1, 1, 1, 1, 1];
                definition[2] = [0, 0, 0, 0, 0];
                definition[3] = [2, 2, 2, 2, 2];
                definition[4] = [0, 1, 2, 1, 0];
                definition[5] = [2, 1, 0, 1, 2];
                definition[6] = [1, 2, 2, 2, 1];
                definition[7] = [1, 0, 0, 0, 1];
                definition[8] = [2, 2, 1, 0, 0];
                definition[9] = [0, 0, 1, 2, 2];
                definition[10] = [2, 1, 1, 1, 0];
                definition[11] = [0, 1, 1, 1, 2];
                definition[12] = [1, 2, 1, 0, 1];
                definition[13] = [1, 0, 1, 2, 1];
                definition[14] = [0, 1, 0, 1, 0];
                definition[15] = [2, 1, 2, 1, 2];
                break;
            case "5x3":
                definition[1] = [1, 1, 1, 1, 1];
                definition[2] = [0, 0, 0, 0, 0];
                definition[3] = [2, 2, 2, 2, 2];
                definition[4] = [0, 1, 2, 1, 0];
                definition[5] = [2, 1, 0, 1, 2];
                definition[6] = [1, 2, 2, 2, 1];
                definition[7] = [1, 0, 0, 0, 1];
                definition[8] = [2, 2, 1, 0, 0];
                definition[9] = [0, 0, 1, 2, 2];
                definition[10] = [2, 1, 1, 1, 0];
                break;
            case "3x3":
                definition[1] = [0, 0, 0];
                definition[2] = [0, 0, 1];
                definition[3] = [0, 0, 2];
                definition[4] = [0, 1, 0];
                definition[5] = [0, 1, 1];
                definition[6] = [0, 1, 2];
                definition[7] = [0, 2, 0];
                definition[8] = [0, 2, 1];
                definition[9] = [0, 2, 2];
                definition[10] = [1, 0, 0];
                definition[11] = [1, 0, 1];
                definition[12] = [1, 0, 2];
                definition[13] = [1, 1, 0];
                definition[14] = [1, 1, 1];
                definition[15] = [1, 1, 2];
                definition[16] = [1, 2, 0];
                definition[17] = [1, 2, 1];
                definition[18] = [1, 2, 2];
                definition[19] = [2, 0, 0];
                definition[20] = [2, 0, 1];
                definition[21] = [2, 0, 2];
                definition[22] = [2, 1, 0];
                definition[23] = [2, 1, 1];
                definition[24] = [2, 1, 2];
                definition[25] = [2, 2, 0];
                definition[26] = [2, 2, 1];
                definition[27] = [2, 2, 2];
                break;
            case "5x4":
                definition[1] = [1, 1, 1, 1, 1];
                definition[2] = [2, 2, 2, 2, 2];
                definition[3] = [0, 0, 0, 0, 0];
                definition[4] = [3, 3, 3, 3, 3];
                definition[5] = [1, 2, 3, 2, 1];
                definition[6] = [2, 1, 0, 1, 2];
                definition[7] = [0, 0, 1, 2, 3];
                definition[8] = [3, 3, 2, 1, 0];
                definition[9] = [1, 0, 0, 0, 1];
                definition[10] = [2, 3, 3, 3, 2];
                definition[11] = [0, 1, 2, 3, 3];
                definition[12] = [3, 2, 1, 0, 0];
                definition[13] = [1, 0, 1, 2, 1];
                definition[14] = [2, 3, 2, 1, 2];
                definition[15] = [0, 1, 0, 1, 0];
                definition[16] = [3, 2, 3, 2, 3];
                definition[17] = [1, 2, 1, 0, 1];
                definition[18] = [2, 1, 2, 3, 2];
                definition[19] = [0, 1, 1, 1, 0];
                definition[20] = [3, 2, 2, 2, 3];
                definition[21] = [1, 1, 2, 3, 3];
                definition[22] = [2, 2, 1, 0, 0];
                definition[23] = [1, 1, 0, 1, 1];
                definition[24] = [2, 2, 3, 2, 2];
                definition[25] = [1, 2, 2, 2, 3];
                definition[26] = [2, 1, 1, 1, 0];
                definition[27] = [0, 0, 1, 0, 0];
                definition[28] = [3, 3, 2, 3, 3];
                definition[29] = [0, 1, 2, 2, 3];
                definition[30] = [3, 2, 1, 1, 0];
                definition[31] = [0, 0, 0, 1, 2];
                definition[32] = [3, 3, 3, 2, 1];
                definition[33] = [1, 0, 0, 1, 2];
                definition[34] = [2, 3, 3, 2, 1];
                definition[35] = [0, 1, 1, 2, 3];
                definition[36] = [3, 2, 2, 1, 0];
                definition[37] = [1, 0, 1, 2, 3];
                definition[38] = [2, 3, 2, 1, 0];
                definition[39] = [0, 1, 2, 3, 2];
                definition[40] = [3, 2, 1, 0, 1];
                break;
            case "4x3":
                definition[1] = [0, 0, 0, 0];
                definition[2] = [0, 0, 0, 1];
                definition[3] = [0, 0, 0, 2];
                definition[4] = [0, 0, 1, 0];
                definition[5] = [0, 0, 1, 1];
                definition[6] = [0, 0, 1, 2];
                definition[7] = [0, 0, 2, 0];
                definition[8] = [0, 0, 2, 1];
                definition[9] = [0, 0, 2, 2];
                definition[10] = [0, 1, 0, 0];
                definition[11] = [0, 1, 0, 1];
                definition[12] = [0, 1, 0, 2];
                definition[13] = [0, 1, 1, 0];
                definition[14] = [0, 1, 1, 1];
                definition[15] = [0, 1, 1, 2];
                definition[16] = [0, 1, 2, 0];
                definition[17] = [0, 1, 2, 1];
                definition[18] = [0, 1, 2, 2];
                definition[19] = [0, 2, 0, 0];
                definition[20] = [0, 2, 0, 1];
                definition[21] = [0, 2, 0, 2];
                definition[22] = [0, 2, 1, 0];
                definition[23] = [0, 2, 1, 1];
                definition[24] = [0, 2, 1, 2];
                definition[25] = [0, 2, 2, 0];
                definition[26] = [0, 2, 2, 1];
                definition[27] = [0, 2, 2, 2];
                definition[28] = [1, 0, 0, 0];
                definition[29] = [1, 0, 0, 1];
                definition[30] = [1, 0, 0, 2];
                definition[31] = [1, 0, 1, 0];
                definition[32] = [1, 0, 1, 1];
                definition[33] = [1, 0, 1, 2];
                definition[34] = [1, 0, 2, 0];
                definition[35] = [1, 0, 2, 1];
                definition[36] = [1, 0, 2, 2];
                definition[37] = [1, 1, 0, 0];
                definition[38] = [1, 1, 0, 1];
                definition[39] = [1, 1, 0, 2];
                definition[40] = [1, 1, 1, 0];
                definition[41] = [1, 1, 1, 1];
                definition[42] = [1, 1, 1, 2];
                definition[43] = [1, 1, 2, 0];
                definition[44] = [1, 1, 2, 1];
                definition[45] = [1, 1, 2, 2];
                definition[46] = [1, 2, 0, 0];
                definition[47] = [1, 2, 0, 1];
                definition[48] = [1, 2, 0, 2];
                definition[49] = [1, 2, 1, 0];
                definition[50] = [1, 2, 1, 1];
                definition[51] = [1, 2, 1, 2];
                definition[52] = [1, 2, 2, 0];
                definition[53] = [1, 2, 2, 1];
                definition[54] = [1, 2, 2, 2];
                definition[55] = [2, 0, 0, 0];
                definition[56] = [2, 0, 0, 1];
                definition[57] = [2, 0, 0, 2];
                definition[58] = [2, 0, 1, 0];
                definition[59] = [2, 0, 1, 1];
                definition[60] = [2, 0, 1, 2];
                definition[61] = [2, 0, 2, 0];
                definition[62] = [2, 0, 2, 1];
                definition[63] = [2, 0, 2, 2];
                definition[64] = [2, 1, 0, 0];
                definition[65] = [2, 1, 0, 1];
                definition[66] = [2, 1, 0, 2];
                definition[67] = [2, 1, 1, 0];
                definition[68] = [2, 1, 1, 1];
                definition[69] = [2, 1, 1, 2];
                definition[70] = [2, 1, 2, 0];
                definition[71] = [2, 1, 2, 1];
                definition[72] = [2, 1, 2, 2];
                definition[73] = [2, 2, 0, 0];
                definition[74] = [2, 2, 0, 1];
                definition[75] = [2, 2, 0, 2];
                definition[76] = [2, 2, 1, 0];
                definition[77] = [2, 2, 1, 1];
                definition[78] = [2, 2, 1, 2];
                definition[79] = [2, 2, 2, 0];
                definition[80] = [2, 2, 2, 1];
                definition[81] = [2, 2, 2, 2];
                break;
            default:
                if (DEBUG) {
                    this.log("ERROR no definition for " + paylineGroupId);
                }
                return;
        }

        this._paylineGroupsDefinitions[paylineGroupId] = definition;
    }

    /**
     * Get payline by id and group id.
     * @method getPaylineDefinitionsById
     * @param paylineId string
     * @param paylineGroupId string
     * @return void
     */
    static getPaylineDefinitionsById(paylineId: number, paylineGroupId: string): Array<number> {
        if (this._paylineGroupsDefinitions != null) {
            if (this._paylineGroupsDefinitions[paylineGroupId] != null) {
                if (this._paylineGroupsDefinitions[paylineGroupId][paylineId] != null) {
                    return this._paylineGroupsDefinitions[paylineGroupId][paylineId];
                } else {
                    if (DEBUG) {
                        this.log("ERROR no paylineId: " + paylineId + " in " + paylineGroupId);
                    }
                }
            } else {
                if (DEBUG) {
                    this.log("ERROR no definition for " + paylineGroupId);
                }
            }
        } else {
            if (DEBUG) {
                this.log("ERROR no paylines definitions");
            }
        }
        return null;
    }

    /**
     * Trace to browser console.
     * @method log
     * @param s string
     * @return void
     */
    private static log(s: string): void {
        if (DEBUG) {
            Logger.debugGroup("PaylineDefinitions", s);
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/GameComponents/PaylinesDefinitions.ts
 **/